import script from "./ConferenceView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConferenceView.vue?vue&type=script&lang=ts&setup=true"

import "./ConferenceView.vue?vue&type=style&index=0&id=f8e40d96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8e40d96"]])

export default __exports__